<template>
  <div>
    <!-- 表单 -->
    <el-form :model="selectQueryParams" ref="queryForm" :inline="true" label-width="70px">
      <el-form-item label="姓名：" prop="username">
        <el-input
          v-model="selectQueryParams.username"
          placeholder="请输入"
          key="username_label"
          clearable
          size="small"
        />
      </el-form-item>

      <el-form-item label="手机号：" prop="tel">
        <el-input
          v-model="selectQueryParams.tel"
          placeholder="请输入"
          key="tel_label"
          clearable
          size="small"
        />
      </el-form-item>

      <el-form-item label="省市区：" prop="areaTreeId">
        <el-cascader
          v-model="selectQueryParams.areaTreeId"
          :options="areaTreesArr"
          clearable
        ></el-cascader>
      </el-form-item>

      <el-form-item label="职称：" prop="title">
        <el-select
          v-model="selectQueryParams.title"
          placeholder="请选择职称"
          key="title_label"
          clearable
          :style="{ width: '100%' }"
        >
          <el-option
            v-for="(item, index) in titleOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
            :disabled="item.disabled"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="单位：" prop="unit">
        <el-select
          v-model="selectQueryParams.unit"
          placeholder="请选择单位"
          key="unit_label"
          clearable
          filterable
          remote
          :remote-method="remoteMethod"
          :style="{ width: '100%' }"
        >
          <el-option
            v-for="(item, index) in unitOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
            :disabled="item.disabled"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="学段：" prop="level">
        <el-select
          v-model="selectQueryParams.level"
          placeholder="请选择学段"
          key="level_label"
          clearable
          :style="{ width: '100%' }"
          @change="handleCourseOptions"
        >
          <el-option
            v-for="(item, index) in levelOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学科：" prop="subject">
        <el-select
          v-model="selectQueryParams.subject"
          placeholder="请选择学科"
          key="subject_label"
          clearable
          :style="{ width: '100%' }"
        >
          <el-option
            v-for="(item, index) in courseOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="角色：" prop="is_teacher">
        <el-select
          v-model="selectQueryParams.is_teacher"
          placeholder="请选择角色"
          key="is_label"
          :style="{ width: '100%' }"
        >
          <el-option
            v-for="(item, index) in is_teacherOptions_T"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="ml16">
        <el-button type="primary" @click="handleStudentQuery">查询</el-button>
        <el-button @click="resetStudentQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table
      :data="selectPostList"
      @selection-change="handleSelectionChange"
      class="user-table mb24"
      :header-cell-style="{
        background: '#F0F0F0',
        fontSize: '14px',
        height: '50px',
        fontWeight: 500,
        color: '#333',
      }"
      @row-click="rowClick"
    >
      <el-table-column label="" align="center" width="50">
        <template slot-scope="scope">
          <el-radio v-model="select_userId" :label="scope.row.id"></el-radio>
        </template>
      </el-table-column>

      <el-table-column label="ID" align="center" prop="id" />
      <el-table-column label="姓名" align="center" prop="truename" />
      <el-table-column label="性别" align="center" prop="sexy_name" />
      <el-table-column
        label="身份证号"
        align="center"
        prop="idnum"
        width="120"
        show-overflow-tooltip
      />
      <el-table-column label="手机号" align="center" prop="tel" width="110" />
      <el-table-column label="省市区" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.province_name }} {{ scope.row.city_name }}
          {{ scope.row.area_name }}
        </template>
      </el-table-column>

      <el-table-column label="单位" align="left" prop="unit_name" show-overflow-tooltip />
      <el-table-column label="学段" align="center" prop="level_name" />
      <el-table-column label="学科" align="center" prop="subject_name" />
      <el-table-column label="职称" align="center" prop="title_name" />
      <el-table-column label="职务" align="center" prop="job" />
      <el-table-column
        label="角色"
        align="center"
        prop="role_name"
        show-overflow-tooltip
      />
      <el-table-column label="注册时间" align="center" prop="create_time" />
    </el-table>
    <!-- 分页 -->
    <Pagination
      :currentPage="currentPage"
      :pageSize="pageSize"
      :total="total"
      :selectSize="[10, 20, 30, 40]"
      @changePage="changePage"
      @changeSize="changeSize"
      v-if="total !== 0"
    ></Pagination>
  </div>
</template>

<script>
import { GetDataList, GetUserList, GetUnitList, SelectStudentAdd } from "@/api/tearcher";
export default {
  data() {
    return {
      addUserDialog: false,
      selectQueryParams: {
        subject: "",
        username: "",
        tel: "",
        title: "",
        unit: "",
        level: "",
        is_teacher: 0,
        areaTreeId: [],
      },
      areaTreesArr: [], // 省市区
      titleOptions: [], // 职称
      unitOptions: [], // 单位
      levelOptions: [], // 学段
      courseOptions: [], // 学科
      selectPostList: [], // 表格列表啊
      is_teacherOptions_T: [
        {
          label: "班主任",
          value: 1,
        },
        {
          label: "教师学员",
          value: 0,
        },
        {
          label: "行政管理员",
          value: 2,
        },
        {
          label: "项目管理员",
          value: 3,
        },
      ],
      currentPage: 1, //当前页数
      pageSize: 10, // 当前页条数
      total: 11, // 总数
      userType: 1, // 1学员，2班主任
      class_id: "", //
      unitSearch: "", //
      select_userId: 0, //选中学员用户id
    };
  },
  created() {},
  methods: {
    //表格行点击
    rowClick(row) {
      this.select_userId = row.id;
    },
    // 单位搜索
    remoteMethod(value) {
      this.unitSearch = value;
      this.getUnitListFn();
    },
    getUnitListFn() {
      GetUnitList({ search: this.unitSearch }).then((res) => {
        this.unitOptions = res.data;
      });
    },
    // 取消按钮
    cancel() {
      this.addUserDialog = false;
    },
    // 确 定
    async submitForm() {
      if (this.select_userId) {
        return this.select_userId;
      }
      // let is_teacher = this.userType === 2 ? 1 : 0;
      // // 添加选择学员
      // SelectStudentAdd({
      //   class_id: this.class_id,
      //   user_ids: this.ids,
      //   user_type: this.user_type,
      //   is_teacher: is_teacher, // 1老师，0学生
      // })
      //   .then((response) => {
      //     if (response.error_code === 201) {
      //       this.messageTips("新增成功", "success");
      //       this.$emit("requestCommonFn");
      //       this.cancel();
      //     }
      //   })
      //   .catch((reason) => {
      //     console.log(reason);
      //   });
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    //获取选择已有用户
    requestCommonFn() {
      let length = this.selectQueryParams.areaTreeId.length;
      let province_id = "";
      let city_id = "";
      let area_id = "";
      if (length > 0) {
        province_id = this.selectQueryParams.areaTreeId[0];
        city_id = this.selectQueryParams.areaTreeId[1];
        area_id = this.selectQueryParams.areaTreeId[2];
      }
      GetUserList({
        page: this.currentPage,
        limit: this.pageSize,
        class_id: this.class_id,
        title: this.selectQueryParams.title,
        username: this.selectQueryParams.username,
        is_teacher: this.selectQueryParams.is_teacher,
        subject: this.selectQueryParams.subject,
        user_type: 1, // 1:选择已有用户,2:选择班主任
        level: this.selectQueryParams.level,
        tel: this.selectQueryParams.tel,
        unit: this.selectQueryParams.unit,
        province_id: province_id,
        city_id: city_id,
        area_id: area_id,
      }).then((res) => {
        this.selectPostList = res.data.list;
        this.total = res.data.total;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      // this.single = selection.length != 1
      // this.multiple = !selection.length
    },
    /** 学生搜索按钮操作 */
    handleStudentQuery() {
      this.currentPage = 1;
      this.requestCommonFn();
    },

    /** 学生重置按钮操作 */
    resetStudentQuery() {
      this.resetForm("queryForm");
      this.order = "";
      this.requestCommonFn();
    },
    // 获取学科列表
    handleCourseOptions(id) {
      this.selectQueryParams.subject = "";
      GetDataList({ type: 5, id: id }).then((response) => {
        this.courseOptions = response.data;
      });
    },
    // 关闭dialog
    closeSubjectDialog() {
      // 重置表单
      this.resetForm("queryForm");
      // 清空表格数据
      //   this.subjectForm.option = [];
    },
    // 操作dialog
    operationDialog(
      areaTreesArr,
      titleOptions,
      unitOptions,
      levelOptions,
      userType,
      class_id
    ) {
      this.addUserDialog = true;
      this.areaTreesArr = areaTreesArr;
      this.titleOptions = titleOptions;
      this.unitOptions = unitOptions;
      this.levelOptions = levelOptions;
      this.userType = userType;
      this.class_id = class_id;
      this.requestCommonFn();
      // 单位搜索
      this.getUnitListFn();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.user-table {
  .el-radio__label {
    display: none;
  }
  .el-table__row {
    cursor: pointer;
  }
}
</style>
